import axios from "axios";

import { getHeader } from "../headers";

// ===================================================================================
//  GET TRANSLATIONS
// ===================================================================================
export const translationsIsLoading = (key, combinedIndexes) => {
	return {
		type: "TRANSLATIONS_IS_LOADING",
		key,
		combinedIndexes
	};
};

export const translationsHasError = (err, key) => {
	return {
		type: "TRANSLATIONS_HAS_ERROR",
		hasErrored: true,
		error: err,
		key
	};
};

export const translationsSuccess = (translations, key, combinedIndexes) => {
	return {
		type: "TRANSLATIONS_SUCCESS",
		translations,
		key,
		combinedIndexes
	};
};

/**
 *
 * Request both pages and sections of translated content.
 * Pages are basically the large overcompassing blurb at the top of each page.  Sections are individual pieces of translatable content (buttons, labels, etc).
 *
 * Page examples: ["home", "training-videos", "reviewer-profile"]
 * Section examples: ["buttons", "form_elements"]
 *
 */
export function getTranslations(pages = [], sections = [], key) {
	// console.log("getTranslations:", key);

	return dispatch => {
		// We will pass the reducer both pages and sections indexes in a single object {pages: {...whatever}, sections: {...whatever}}
		const combinedIndexes = {
			pages,
			sections
		};

		// Set loading for the pages/sections being requested
		dispatch(translationsIsLoading(key, combinedIndexes));

		// Set params being requested for both pages and sections.
		// These will be objects passed as params that the API will make sense of
		const contents = {};
		if (pages.length) {
			contents.pages = pages;
		}

		if (sections.length) {
			contents.sections = sections;
		}

		let params = {
			contents,
			language: process.env.REACT_APP_LANGUAGE
		};

		return axios
			.get(process.env.REACT_APP_API_URL + "translations", {
				headers: getHeader(),
				params
			})
			.then(response => {
				return dispatch(
					translationsSuccess(response.data.translations, key, combinedIndexes)
				);
			})
			.catch(err => {
				// console.log("getTranslations error:", err);
				// return Promise.reject(dispatch(translationsHasError(err)));
				return dispatch(translationsHasError(err, key));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/translations.js